import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-781cfb55"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "huddles-card" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "panel panel--flight" }
const _hoisted_4 = { class: "revenue-goal-header" }
const _hoisted_5 = { class: "panel panel--goals" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))

import Typography from '@/components/Rain/Typography/Typography.vue'
import HuddlesMetric from '@/mobile/src/views/appV4/huddles/HuddlesMetric.vue'
import { palette } from '@/utils/palette'
import { FontAwesomeIcon } from 'fontawesome/vue-fontawesome'
import { faFlag } from 'fontawesome/pro-regular-svg-icons'

interface Props {
    revenueTotalTarget: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HuddlesRevenueGoal',
  props: {
    revenueTotalTarget: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(FontAwesomeIcon), {
            icon: _unref(faFlag),
            size: "xl"
          }, null, 8, ["icon"]),
          _createVNode(Typography, { variant: "h4" }, {
            default: _withCtx(() => [
              _createTextVNode("Today’s Total Revenue Goal")
            ], undefined, true),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(HuddlesMetric, {
          "top-label": "Total Revenue Goal",
          "metric-value": _ctx.revenueTotalTarget,
          "value-color": _unref(palette).successGreen
        }, null, 8, ["metric-value", "value-color"])
      ])
    ])
  ]))
}
}

})